import { render, staticRenderFns } from "./CompaniesView.yaml?vue&type=template&id=36a341c3&component"
import script from "./CompaniesView.yaml?vue&type=script&lang=ts&component"
export * from "./CompaniesView.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports